module.exports = __webpack_public_path__ + "img/opdrachten-icon.6e78b07.png";